


  <div class="Dialog-body">
    <div class="modal-header">   
      <!-- <div class="sc-badge sc-safe" style="padding: 4px 3px !important;"></div> -->
  </div>

  
    <div class="sc-icon">
      <i class="material-icons">add</i>
      <span style="padding-left: 8px;">Pick a different file</span>
      
    </div>

    <div  class="example-full-width" style="width: 500px;display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;">
      
      <div>
        <label>             
          <input type="file" #fileUploader1  name="upload" accept="application/pdf,application/vnd.ms-excel" (change)="onFileChangedGET($event);">       
        </label>
      </div>
    </div>

    

  
    <div class="buttonbelow">
      <button mat-button (click)="DialogClose()">Submit</button>
      <button mat-button  (click)="DialogClose_()" >Cancel</button>    
    </div>
     
 

</div>
